import { ErrorPage2Column } from "@components"
import { ReactComponent as AuthSvg } from "@svgs/graphs/auth.svg"

const UserNotFound = () => (
  <ErrorPage2Column
    errorCode={401}
    title="Authentication Error"
    subTitle="Sorry, we couldn’t verify your identity. Please contact your administrator to ensure your SchoolBooking account is associated with an existing staff member in Parents."
    image={<AuthSvg className="h-2/6 xl:h-3/6 w-auto max-w-[600px]" />}
  />
)

export default UserNotFound
